import { Allocation } from "@/api/SolarCloudApi";
import { cn } from "@/util/cn";
import AllocationCard from "./AllocationCard";

type AllocationsProps = {
  allocations: Allocation[];
  className?: string;
  unallocatedWatts: number;
  account: "gas" | "electricity" | "bank" | undefined;
  deleteAllocation: (allocation: Allocation) => void;
  updateAllocation: (allocation: Allocation) => void;
  moveAllocation: (allocation: Allocation, direction: "up" | "down") => void;
};

export default function Allocations({
  allocations,
  className,
  unallocatedWatts,
  account,
  deleteAllocation,
  updateAllocation,
  moveAllocation,
}: AllocationsProps) {
  return (
    <div className={cn("max-w-lg mx-auto", className)}>
      {allocations.length > 0 && (
        <div className="h-[1px] bg-brand-orange-500/65 w-2/3 mx-auto" />
      )}
      {allocations.map((allocation, index) => (
        <div key={allocation.uuid}>
          <AllocationCard
            allocation={allocation}
            deleteAllocation={deleteAllocation}
            updateAllocation={updateAllocation}
            unallocatedWatts={unallocatedWatts}
            moveAllocation={moveAllocation}
            isFirst={index === 0}
            isLast={index === allocations.length - 1}
            account={account}
          />
          {index < allocations.length - 1 && (
            <div className="h-[1px] bg-brand-orange-500/65 w-2/3 mx-auto" />
          )}
        </div>
      ))}
    </div>
  );
}
